
import React from 'react'
import Headers from '../../components/application/headers'
import DashboardContent from '../../components/application/dashboard'

function Dashboard() {
  return (
    <>
    <Headers/>
    <DashboardContent/>
    </>
  )
}

export default Dashboard